import styled from 'styled-components';
import ChartRect from '../ChartRect/ChartRect.styles';

const ChartBarsGroupWrapper = styled.g`
  &:hover {
    ${ChartRect} {
      opacity: 1;
    }
  }
`;

export default ChartBarsGroupWrapper;
